import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'
import {environment} from '../../../environments/environment.prod';
import { Subscription } from 'rxjs';
import { UserLanguageService } from '../services/user-language-service/user-language.service';

import { MatDialog } from '@angular/material/dialog';
import {LocalStorageService} from "../services/localStorage-service/local-storage.service";

declare var FB: any
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {

  lang
  langSub: Subscription;

  labels;
  labelsSub: Subscription;

  redirectUrl: string

  constructor(private router: Router, private languageService: UserLanguageService,
    public dialog: MatDialog, public localService: LocalStorageService) {
  }

  ngOnInit(): void {

    this.langSub = this.languageService.lang$.subscribe((lang) => {
      this.lang = lang;
    })
    this.labelsSub = this.languageService.labels$.subscribe((labels) => {
      this.labels = labels;
    })

    this.localService.clear()
    this.redirectUrl = environment.serversIpAddress + "login"

    setTimeout(() => {
      window.location.href = this.redirectUrl;
    }, 500);
  }

  ngOnDestroy(): void {
    this.langSub.unsubscribe();
    this.labelsSub.unsubscribe();
  }

}
